import React from 'react';
import {useSelector} from 'react-redux';

import {labels} from '../../../../../../../util/utils';
import {lightColor} from '@ey/styled-theme';

import StackedBarChart from '../../../../../Charts/StackedBarChart';

export const prop = 'status';

const StatusColumn = (item) => {
	const {allTC, allTIR, allTIP, allTO} = item;
	const numberFormat = useSelector(({userPreferences}) => userPreferences.numberFormat);

	return (
		<StackedBarChart
			key={`${item?.engId}-${item?.tableClass}`}
			numberFormat={numberFormat}
			series={[
				{
					name: labels.completeUpperCase,
					data: [allTC],
					color: lightColor['green700']
				},
				{
					name: labels.inReview,
					data: [allTIR],
					color: lightColor['green500']
				},
				{
					name: labels.inProgress,
					data: [allTIP],
					color: lightColor['green400']
				},
				{
					name: labels.open,
					data: [allTO],
					color: lightColor['grey300']
				}
			]}
		/>
	);
};

export const config = (headers) => ({
	id: 'taskStatusColumn',
	label: headers.taskStatus,
	propName: prop,
	width: 'minmax(var(--px-250), 3fr)',
	customCell: (item) => <StatusColumn {...item} />
});
